const copyToClip = (content, message) => {
  var aux = document.createElement('input')
  aux.setAttribute('value', content)
  document.body.appendChild(aux)
  aux.select()
  document.execCommand('copy')
  document.body.removeChild(aux)
  if (message === null) {
    alert('复制成功')
  } else {
    alert(message)
  }
}

const transformNumberIntoCHS = (number) => {
  var numReg = /^(0|[1-9]\d*)(\.\d{1,2})?$/
  var testResult = numReg.test(number)
  if (!testResult || number === '0' || number === 0) {
    return ''
  }
  var unit = '仟佰拾亿仟佰拾万仟佰拾元角分'
  var str = ''
  number += '00'
  var point = number.indexOf('.')
  if (point >= 0) {
    number = number.substring(0, point) + number.substr(point + 1, 2)
  }
  unit = unit.substr(unit.length - number.length)
  for (var i = 0; i < number.length; i++) {
    str += '零壹贰叁肆伍陆柒捌玖'.charAt(number.charAt(i)) + unit.charAt(i)
  }
  return str.replace(/零(仟|佰|拾|角)/g, '零').replace(/(零)+/g, '零').replace(/零(万|亿|元)/g, '$1').replace(/(亿)万|(拾)/g, '$1$2').replace(/^元零?|零分/g, '').replace(/元$/g, '元整')
}

const userType = {
  '1': '游客',
  '3': '保证人',
  '5': '监管人',
  '7': '总监管人',
  '9': '总承包',
  '11': '业主',
  '127': '管理员'
}

const cityTier = {
  '1': '省级',
  '2': '地市级',
  '3': '县区级',
  '7': '乡镇级'
}

const companyType = {
  '0': '未知',
  '1': '总承包',
  '2': '专业承包',
  '3': '劳务分包',
  '4': '业主',
  '5': '工程监理',
  '6': '工程设计',
  '7': '工程造价咨询',
  '8': '规划编制'
}

const guarantorStatus = {
  '-1': '草稿',
  '0': '未备案',
  '1': '预审中',
  '2': '待审核',
  '3': '已备案',
  '40': '异常',
  '99': '退回'
}

const guarantorStatusColor = {
  '-1': 'warning',
  '0': 'default',
  '1': 'orange',
  '2': 'magenta',
  '3': 'success',
  '40': 'error',
  '99': 'error'
}

const guaranteeRenewalStatus = {
  '0': '待审核',
  '1': '已审核',
  '2': '已拒绝'
}

const guaranteeRenewalStatusColor = {
  '0': 'orange',
  '1': 'success',
  '2': 'error'
}

const guaranteeCorrectionStatus = {
  '0': '待整改',
  '1': '已提交',
  '2': '未通过',
  '3': '已整改'
}

const guaranteeCorrectionStatusColor = {
  '0': 'orange',
  '1': 'blue',
  '2': 'error',
  '3': 'success'
}

const guaranteeStatus = {
  '0': '待确认',
  '1': '已确认',
  '2': '审核解除中',
  '3': '已解除',
  '4': '代偿',
  '5': '追偿',
  '6': '退回',
  '7': '草稿',
  '8': '已提交'
}

// const guaranteeStatus = {
//   '0': '备案审核中',
//   '1': '已备案',
//   '2': '审核解除中',
//   '3': '已解除',
//   '4': '代偿',
//   '5': '追偿',
//   '6': '退回',
//   '7': '草稿',
//   '8': '备案预审中'
// }

// 在保的状态
const undergoingStatus = [0, 1, 2]

const guaranteeStatusColor = {
  '0': 'primary',
  '1': 'success',
  '2': 'cyan',
  '3': 'default',
  '4': 'magenta',
  '5': 'magenta',
  '6': 'error',
  '7': 'orange',
  '8': 'orange'
}

const guaranteeVarietyColor = {
  '1': 'blue',
  '2': 'orange',
  '3': 'cyan',
  '4': 'magenta',
  '5': 'gold',
  '6': 'green',
  '7': 'lime',
  '9': 'primary',
  '99': 'gold'
}

const expertType = {
  '0': '注册监理工程师',
  '1': '注册建造师'
}

const contractorType = {
  '1': '总承包',
  '2': '专业承包',
  '3': '劳务'
}

const guarantorType = {
  '1': '担保公司',
  '2': '国有银行',
  '3': '股份制银行',
  '10': '保险公司',
  '99': '其他'
}

const gMethod = {
  '0': '独立保证',
  '2': '联合保证'
}

// 代偿方式
const claimMethod = {
  '0': '提供一笔资金',
  '1': '向承包商提供施工机械设备',
  '2': '向承包商提供技术与管理经验',
  '3': '向承包商提供施工劳动力',
  '4': '提供高一级施工资质承包商继续施工',
  '5': '担保公司自己组织施工'
}

// 代偿原因（业主方面）
const claimReasonByOwner = {
  '0': '资金断链',
  '1': '开发法律手续不齐',
  '2': '销售手续不齐',
  '3': '行业政策变化',
  '4': '职业道德',
  '5': '其他'
}

// 代偿原因（承包商方面）
const claimReasonByContractor = {
  '0': '资质挂靠施工',
  '1': '违法转包',
  '2': '资金投入不足',
  '3': '施工机械投放不足',
  '4': '周转材料投入不足',
  '5': '劳动力投入不足',
  '6': '项目管理人员配套或数量不足',
  '7': '项目经营模式',
  '8': '管理能力',
  '9': '企业经营状况变化',
  '10': '职业道德',
  '11': '其他'
}

const companyCreditRecordType = {
  '0': '履约记录',
  '1': '失信记录'
}

// 公告类型
const announcementType = {
  '0': '公告',
  '1': '公示',
  '11': '缴存公示',
  '12': '完工公示',
  '13': '差异化公示',
  '2': '政策法规',
}

// 缴存申请单状态
const projectRegisterStatus = {
  '0': '待确认',
  '1': '已确认',
  '2': '已拒绝',
  '3': '已作废',
  '4': '待审核'
}

const projectRegisterStatusColor = {
  '0': 'warning',
  '1': 'success',
  '2': 'error',
  '3': 'default',
  '4': 'primary'
}

const appraisalQuestionType = {
  '0': '文本',
  '1': '数值',
  '2': '布尔',
  '3': '一票否决',
  '4': '列表',
  '5': '文件上传',
  '6': '选择',
  '7': '分类列表'
}

const appraisalStatus = {
  '0': '待自评',
  '1': '待审核',
  '2': '已审核',
  '9': '草稿'
}

const appraisalStatusColor = {
  '0': 'primary',
  '1': 'warning',
  '2': 'success',
  '9': 'error'
}

const getEnumSelect = (enums) => {
  let list = []
  for (var p in enums) {
    list.push({
      key: p,
      value: enums[p]
    })
  }
  return list
}

const checkHasLowerCase = (str) => {
  let regx = /(?=.*[a-z])/
  return regx.test(str)
}

const checkHasUpperCase = (str) => {
  let regx = /(?=.*[A-Z])/
  return regx.test(str)
}

const checkHasNumber = (str) => {
  let regx = /(?=.*[0-9])/
  return regx.test(str)
}

const checkHasSymbol = (str) => {
  let regx = /(?=.*[!@#$%^&*])/
  return regx.test(str)
}

const checkStrCharacterTypes = (str) => {
  let typeCount = 0
  let types = []
  if (checkHasLowerCase(str)) {
    typeCount++
    types.push('lowerCase')
  }
  if (checkHasUpperCase(str)) {
    typeCount++
    types.push('upperCase')
  }
  if (checkHasNumber(str)) {
    typeCount++
    types.push('number')
  }
  if (checkHasSymbol(str)) {
    typeCount++
    types.push('symbol')
  }
  return {
    count: typeCount,
    types: types
  }
}

const searchQueryString = (key) => {
  try {
    var qsArr = window.location.search.substr(1).split('&')
    var hit = qsArr.filter(function (val) {
      return val.indexOf(key + '=') === 0
    })
    if (hit) {
      return hit[0].split('=')[1]
    }
  } catch (err) {
    return ''
  }
}

const getCookie = (name) => {
  var prefix = name + '='
  var start = document.cookie.indexOf(prefix)

  if (start === -1) {
    return null
  }

  var end = document.cookie.indexOf(';', start + prefix.length)
  if (end === -1) {
    end = document.cookie.length
  }

  var value = document.cookie.substring(start + prefix.length, end)
  return unescape(value)
}

module.exports = {
  copyToClip,
  transformNumberIntoCHS,
  userType,
  cityTier,
  companyType,
  expertType,
  contractorType,
  guarantorType,
  getEnumSelect,
  guaranteeStatus,
  gMethod,
  undergoingStatus,
  guaranteeStatusColor,
  guaranteeVarietyColor,
  guarantorStatus,
  guarantorStatusColor,
  guaranteeRenewalStatus,
  guaranteeRenewalStatusColor,
  guaranteeCorrectionStatus,
  guaranteeCorrectionStatusColor,
  claimMethod,
  claimReasonByContractor,
  claimReasonByOwner,
  checkStrCharacterTypes,
  searchQueryString,
  getCookie,
  announcementType,
  projectRegisterStatus,
  projectRegisterStatusColor,
  companyCreditRecordType,
  appraisalQuestionType,
  appraisalStatus,
  appraisalStatusColor
}
